import $ from 'jquery';
import 'select2';

const settings = {
  theme: 'classic',
  language: {
    noResults: function () {
      return 'Nenhum resultado encontrado.';
    },
  },
  escapeMarkup: function (markup) {
    return markup;
  },
};

const select = {
  stateCity() {
    const dfOpt = new Option('Selecione a cidade', '');

    $('.js-state-filter')
      .select2({
        ...settings,
      })
      .on('change', function (e) {
        var post = {};

        if (e.target.value) {
          post.id = e.target.value;
          post._token = $('meta[name="csrf-token"]').attr('content');

          var url = '/estados/busca-cidades/' + post.id;

          $.ajax({
            type: 'GET',
            url: url,
            data: post,
            cache: false,
            dataType: 'json',
          }).then(function (data) {
            $('#js-cities').empty().append(dfOpt);

            $.each(data, function (index, element) {
              var option = new Option(element, index);
              $('#js-cities').append(option);
            });
          });
        }
      });

    $('#js-cities').select2({
      ...settings,
    });
  },

  area() {
    $('.js-areas').select2({
      placeholder: 'Selecione sua área',
      ...settings,
    });
  },

  unity() {
    $('.js-unity').select2({
      placeholder: 'Selecione sua unidade',
      ...settings,
    });
  },

  funcional() {
    $('.js-funcional').select2({
      placeholder: 'Selecione sua categoria funcional',
      ...settings,
    });
  },

  vp() {
    $('.js-vicepresident')
      .select2({
        placeholder: 'Selecione sua Vice-Presidência',
        theme: 'classic',
      })
      .on('change', function (e) {
        var post = {};

        $('.js-superintendent').empty();
        $('.js-regional').empty();
        $('.js-superintendent').append($('<option></option>').attr('value', '').text('Carregando...'));
        $('.js-regional').empty();

        post.id = e.target.value;
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = '/busca-superintendencias/' + post.id;

        $.ajax({
          type: 'GET',
          url: url,
          data: post,
          cache: false,
          dataType: 'json',
          success: function (data) {
            if (data) {
              $('.js-superintendent').empty();

              $('.js-superintendent').append(
                $('<option></option>').attr('value', '0').text('Selecione sua superintendência')
              );
              $.each(data, function (index, element) {
                $('.js-superintendent').append($('<option></option>').attr('value', index).text(element));
              });
            }
          },
        });
      });
  },

  groups() {
    $('.js-groups').select2({
      placeholder: 'Selecione um grupo',
      ...settings,
    });
  },
};

export const stateCity = select.stateCity;
export const area = select.area;
export const unity = select.unity;
export const funcional = select.funcional;
export const vp = select.vp;
export const groups = select.groups;
